/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
/**
 * The TenantTypes enum.
 */
export enum ApplicationStatusTypesEnum {
  /**
   * Application Form Status Type enum: Invited
   */
  INVITED = "Invited",

  /**
   * Application Form Status Type enum: Not Submitted
   */
  NOT_SUBMITTED = "Not Submitted",

  /**
   * Application Form Status Type enum: Saved
   */
  SAVED = "Saved",

  /**
   * Application Form Status Type enum: Review Eligible
   */
  REVIEW_ELIGIBLE = "Review Eligible",

  /**
   * Application Form Status Type enum: Under Review
   */
  UNDER_REVIEW = "Under Review",
  Declined = "Declined",
  DeclinePending = "Declined-Pending",
  InvitedPending = "Invited-Pending",
  DecisionPending = "Decision-Pending",
  AutoDeclined = "Auto Declined",
  Submitted = "Submitted",
}

export const APPLICATION_STATUS_DROPDOWN_OPTIONS = [
  {
    key: ApplicationStatusTypesEnum.InvitedPending,
    text: ApplicationStatusTypesEnum.InvitedPending,
  },
  {
    key: ApplicationStatusTypesEnum.DeclinePending,
    text: ApplicationStatusTypesEnum.DeclinePending,
  },
  {
    key: ApplicationStatusTypesEnum.DecisionPending,
    text: ApplicationStatusTypesEnum.DecisionPending,
  },
];
